{
  "siteUrl": "https://mypt.com.tr"
}
